/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Purpose of an attachment. The meaning of <c>Key</c> depends on the category.
 */
export enum EnumAttachmentCategory {
    /**
     * A plain attachment without a specific purpose. Has no key.
     */
    None = 0,
    /**
     * A supplied document served in place of a rendered printout. The key is the print option id.
     */
    Printout = 1,
}
